// Generated by ts-to-zod
import { z } from 'zod';
import { functionConfigSchema } from '../models/hookConfig.schema';

export const testPayloadSchema = z.object({
  config: functionConfigSchema,
  payload: z.unknown().optional(),
});

export const testResponseSchema = z.object({
  log: z.string().nullable(),
  response: z.unknown().optional(),
  stacktrace: z.string().optional().nullable(),
});
